export const REPORT_CARD_CONTENT_ORDER_HISTORY =
  'REPORT_CARD_CONTENT_ORDER_HISTORY';
export const REPORT_CARD_CONTENT_PREMIER_CANCELLATIONS =
  'REPORT_CARD_CONTENT_PREMIER_CANCELLATIONS';
export const REPORT_CARD_CONTENT_PROJECTED_PREMIER_VOLUME =
  'REPORT_CARD_CONTENT_PROJECTED_PREMIER_VOLUME';
export const REPORT_CARD_CONTENT_NEW_CLIENTS_WITHOUT_ORDERS =
  'REPORT_CARD_CONTENT_NEW_CLIENTS_WITHOUT_ORDERS';
export const REPORT_CARD_CONTENT_EXPIRING_COACH_RENEWAL =
  'REPORT_CARD_CONTENT_EXPIRING_COACH_RENEWAL';
export const REPORT_CARD_CONTENT_PROMOTION = 'REPORT_CARD_CONTENT_PROMOTION';
export const REPORT_CARD_CONTENT_ELIGIBLE_FOR_CAB =
  'REPORT_CARD_CONTENT_ELIGIBLE_FOR_CAB';
export const REPORT_CARD_CONTENT_ELIGIBLE_FOR_QSB =
  'REPORT_CARD_CONTENT_ELIGIBLE_FOR_QSB';
export const REPORT_CARD_CONTENT_TEAM_RANK = 'REPORT_CARD_CONTENT_TEAM_RANK';
export const REPORT_CARD_CONTENT_ALL_COACHES =
  'REPORT_CARD_CONTENT_ALL_COACHES';
export const REPORT_CARD_CONTENT_NEW_COACHES =
  'REPORT_CARD_CONTENT_NEW_COACHES';
export const REPORT_CARD_CONTENT_CLOSE_TO_SC =
  'REPORT_CARD_CONTENT_CLOSE_TO_SC';
export const REPORT_CARD_CONTENT_CLOSE_TO_ED =
  'REPORT_CARD_CONTENT_CLOSE_TO_ED';
export const REPORT_CARD_CONTENT_CLOSE_TO_FIBC =
  'REPORT_CARD_CONTENT_CLOSE_TO_FIBC';
export const REPORT_CARD_CONTENT_EARNED_CAB = 'REPORT_CARD_CONTENT_EARNED_CAB';
export const REPORT_CARD_CONTENT_EARNED_QSB = 'REPORT_CARD_CONTENT_EARNED_QSB';
export const REPORT_CARD_CONTENT_EMPTY = 'REPORT_CARD_CONTENT_EMPTY';
export const REPORT_CARD_INACTIVE_CLIENTS = 'REPORT_CARD_INACTIVE_CLIENTS';
export const REPORT_CARD_EXPIRING_WELLNESS = 'REPORT_CARD_EXPIRING_WELLNESS';
export const REPORT_CARD_EXPIRING_REWARDS = 'REPORT_CARD_EXPIRING_REWARDS';
export const REPORT_CARD_ELIGIBLE_ACCELERATOR_BONUS =
  'REPORT_CARD_ELIGIBLE_ACCELERATOR_BONUS';
export const REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS =
  'REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS';

export const REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR =
  'REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR';

export const REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX =
  'REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX';

export const REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO =
  'REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO';
export const REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE =
  'REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE';
export const REPORT_CARD_EARNED_ACCELERATOR_BONUS =
  'REPORT_CARD_EARNED_ACCELERATOR_BONUS';
export const REPORT_CARD_EARNED_CLIENT_SUPPORT_BONUS_PLUS =
  'REPORT_CARD_EARNED_CLIENT_SUPPORT_BONUS_PLUS';
export const REPORT_CARD_ELIGIBLE_FOR_INCENTIVE_TRIP =
  'REPORT_CARD_ELIGIBLE_FOR_INCENTIVE_TRIP';
export const REPORT_CARD_QUALIFIED_FOR_INCENTIVE_TRIP =
  'REPORT_CARD_QUALIFIED_FOR_INCENTIVE_TRIP';

export const SEARCH_CARD_COACHES_CONTENT = 'SEARCH_CARD_COACHES_CONTENT';
export const SEARCH_CARD_CLIENT_CONTENT = 'SEARCH_CARD_CLIENT_CONTENT';
